"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeMetadata = exports.decodeMetadata = void 0;
const js_base64_1 = require("js-base64");
const decodeMetadata = (encodedMetadata) => {
    try {
        return JSON.parse(js_base64_1.Base64.decode(encodedMetadata));
    }
    catch (e) {
        return {};
    }
};
exports.decodeMetadata = decodeMetadata;
/**
 * Encodes metadata object to be url-safe
 * @param metadata the metadata object
 */
const encodeMetadata = (metadata) => {
    try {
        return js_base64_1.Base64.encode(JSON.stringify(metadata || {}), true);
    }
    catch (e) {
        return js_base64_1.Base64.encode(JSON.stringify({}), true);
    }
};
exports.encodeMetadata = encodeMetadata;
//# sourceMappingURL=typesUtils.js.map